var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('index_layout',{attrs:{"searchPath":"/booksearch"}},[_c('elink'),_vm._v(" "),_c('template',{slot:"ft"},[_c('mfooter',{attrs:{"elink":true}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }